export * from './user-avatar/user-avatar.component';
